import { gql } from "@apollo/client";

export const VOID_CITATION = gql`
  mutation VoidCitation($id: uuid!, $reason: String!, $voidedAt: timestamptz!) {
    void_citation(id: $id, reason: $reason, voided_at: $voidedAt) {
      citationId: citation_id
      voidedAt: voided_at
      reason
      updatedAt: updated_at
    }
  }
`;

export interface VoidCitationData {
  void_citation: {
    citationId: string;
    voidedAt: string;
    reason: string;
    updatedAt: string;
  };
}

export interface VoidCitationVars {
  id: string;
  reason: string;
  voidedAt: Date;
}

export default VOID_CITATION;
